<img class="logo-custom" *ngIf="logo; else defaultLogo" [src]="logo"/>
<ng-template #defaultLogo>
  <i class="logo-icon" [inlineSVG]="'assets/icons/logo.svg'" [resolveSVGUrl]="false"></i>
</ng-template>
